import {CONTEXT_RESOLVED_VALUE} from '../symbols';
import log from '../log';

const contexts = new Map();
const getContext = contextKey => {
	if (contexts.has(contextKey)) {
		const context = contexts.get(contextKey) || {};
		const resolvedValue = context[CONTEXT_RESOLVED_VALUE];
		if (resolvedValue !== undefined) {
			return resolvedValue;
		} else if (context.default !== undefined) {
			return context.default;
		}
	}
	return undefined;
};

const setContext = (contextKey, value) => {
	if (contexts.has(contextKey)) {
		contexts.get(contextKey)[CONTEXT_RESOLVED_VALUE] = value;
	} else {
		if (process.env.NODE_ENV !== 'production') {
			log(
				`The context "${contextKey?.toString()}" could not be accessed. Context must be defined using the "createContext" function. "createContext" can imported from @servicenow/ui-core.`,
				{
					origin: 'context'
				}
			);
		}
	}
};

export default contexts;
export {getContext, setContext};
